import script from "./classInstanceDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./classInstanceDetails.vue?vue&type=script&setup=true&lang=js"

import "./classInstanceDetails.vue?vue&type=style&index=0&id=4385c87a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4385c87a"]])

export default __exports__